import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountOwnerSelect } from '../../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { SelectAnnuityType } from '../../components/AnnuityType/SelectAnnuityType';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Balance } from '../../components/Balance/Balance';
import { Comments } from '../../components/Comments/Comments';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AnnuityRiders } from '../../components/AnnuityRiders/AnnuityRiders';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { AnnuitizationYear } from '../../components/AnnuitizationYear/AnnuitizationYear';
import { AnnuitizationByYear } from '../../components/AnnuitizationByYear/AnnuitizationByYear';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { Contributions } from '../../components/Contributions/Contributions';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { ExclusionRatio } from '../../components/ExclusionRatio/ExclusionRatio';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountModalUsageContext } from '../../context/AccountFormProvider.meta';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  const { watch } = useFormContext();

  const { usageContext } = useAccountFormContext();

  const annuityIsAlreadyAnnuitized = watch('bankAccount.AnnuityIsAlreadyAnnuitized');

  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnerSelect />
      <AccountDescription />
      <AccountNickname />
      <SelectAnnuityType />
      {!annuityIsAlreadyAnnuitized &&
        usageContext !== AccountModalUsageContext.AnnuityPurchaseWhatIf && (
          <Balance label="Current Market Value" />
        )}
      <Contributions />
      <Comments />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const PolicyDetails = () => {
  const { usageContext } = useAccountFormContext();

  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>
      {usageContext !== AccountModalUsageContext.AnnuityPurchaseWhatIf && <AccountEarmark />}
      <AnnuitizationYear />
      <AnnuitizationByYear />
      <ExclusionRatio />
      <AccountFees />
    </TabWrapper>
  );
};

const Riders = () => {
  return (
    <TabWrapper>
      <AnnuityRiders />
    </TabWrapper>
  );
};

export const Annuity = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Policy Details', Component: PolicyDetails },
        { name: 'Riders', Component: Riders },
      ]}
    />
  );
};
